<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-trash icons  mr-2"></i>Remove Shipment </strong>           
          </div>   
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >
                <b-form-group label="Shipment Id"  :label-cols="3" >
                   <b-form-input class="input" type="text" name="shipmentid" v-model="customer.shipmentid" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.shipmentid') }" placeholder="Enter shipment id ">
                 
                   </b-form-input>
                  <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                </b-form-group>
                </b-col>
                <b-col md="6" >
                  <b-button class="mr-2" type="submit" size="md" variant="primary">Remove Shipment </b-button>
                  <b-button  @click="clear" size="md" variant="danger">Clear</b-button>
                </b-col>
              </b-row> 
            </form>
          </div> 
          <b-modal title="Confirmation Box" v-model="toggleInfo" size="sm" @ok="toggleInfoModal = false">
            <template slot="modal-header" slot-scope="{ close }">
            <h5>Remove shipment</h5>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <form v-on:submit.prevent="toggleInfoModal(value)">
                <div class="modal-background"></div>
                <div class="modal-card">
                  <section class="modal-card-body">                          
                    <span> Are you sure to Remove shipment?</span>
                  </section>
                  <footer slot="modal-footer">
                    <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                  </footer>
                </div>
              </form>
            </template>
            <footer slot="modal-footer" slot-scope="{ cancel }">
              <b-button size="sm" variant="danger" @click="closemodal">
                Cancel
              </b-button>
            </footer>
          </b-modal>
        </b-card>
      </b-col>    
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      name: 'removeshipment',
      customer: {},
      data: [],
      toggleInfo: false
    }
  },
  created: function () {},
  methods: {
    validateForm  (scope) {

      this.$validator.validateAll(scope).then((result) => {
     
        if (result) {

          this.toggleInfo = !this.toggleInfo
        }
      })
    },
    clear: function () {
      this.customer = {}
      this.errors.clear('form-1')
      var searchlisting = document.getElementById('searchlisting')
      searchlisting.style.display = 'none'
    },
    toggleInfoModal: function () {
      var searchvaluesarr = [];
      var shipmentid = this.customer.shipmentid;
      var statuscode = 1;
      var userdata = localStorage.getItem('userData');
      var userInfo = JSON.parse(userdata);
      var searchvalues = shipmentid.split(',');
      for (var i = 0; i < searchvalues.length; i++) {
        searchvaluesarr.push(`${searchvalues[i]}`)
      }
      const customerGetAllobj = {
        shippingid: searchvaluesarr,
        deliverystatuscode: statuscode,
        lastmodifiedby: `${userInfo.sysemailid}`,
        status:'ClientPickCancel'
      }
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/MarkPickupCancelShipment`, customerGetAllobj)
        .then((result) => {
          if (result.body[0].returnmsg.toLowerCase() === 'successful') {
            Utils.notify('Remove shipment successfully', 'success');
          } else {
            Utils.notify(result.body[0].returnvalue,'error');
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      this.toggleInfo = !this.toggleInfo
    },
    closemodal: function () {
      // console.log('closemodal')
      this.toggleInfo = !this.toggleInfo
    }
  }
}
</script>

